import React from 'react'
import {
    List,
    Datagrid,
    TextField, EditButton
} from 'react-admin'

const SubPanelsList = (props: any) => {
    return (
        <List bulkActionButtons={false} perPage={50} {...props} >
            <Datagrid>
                <TextField source='id' />
                <TextField source='panel_id' />
                <TextField source='panel_uuid' />
                <TextField source='panel_name' />
                <EditButton label="Edit settings" />
            </Datagrid>
        </List>
    )
}

export default SubPanelsList
